import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";

import { Security } from "../../resources";

export interface SynchronizeRoleRequest {
  id: number;
  command: string;
  actionArgument: string;
}

@Injectable()
export class SecurityService extends BaseDataService<Security> {
  constructor(http: HttpService) {
    super(http, "security");
  }

  createInstance(options: any): Security {
    return new Security(options);
  }

  synchronize(request: SynchronizeRoleRequest) {
    return this.runCommand("synchronize", request);
  }
}
